module.exports = __webpack_public_path__ + "static/media/promo_1.513dd30a.jpg";